import { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  deleteSuperPower,
  deleteSuperPowerTranslation,
  getSuperPowers,
  storeSuperPower,
  updateSuperPower,
} from "../../services/superPower.service";
import DataTable from "../../components/globals/data-table/data-table";
import { Controller, FormProvider, useForm } from "react-hook-form";
import Modal3 from "../../components/modal3/modal3";
import TextInput2 from "../../components/form-elements/TexInput2/TextInput2";
import TextArea2 from "../../components/form-elements/TextArea2/textArea2";
import useSnackbarStore from "../../store/snackbarStore";
import debounce from "lodash.debounce";
import SecondModal from "../../components/form-elements/second-modal/second-modal";
import SelectInput from "../../components/form-elements/SelectInput/SelectInput";
import { getAllLocales } from "../../services/locale.service";
import { getAllSuperPowerTypes } from "../../services/super-power-type.service";
import { getAllModels } from "../../services/model.service";
import ToggleSwitch3 from "../../components/form-elements/ToogleSwitch3/ToogleSwitch3";
import { v4 as uuidv4 } from "uuid";

const SuperPower = () => {
  const [superPowers, setSuperPowers] = useState();
  const [searchLoading, setSearchLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const [selectedTranslation, setSelectedTranslation] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const methods = useForm();
  const { show } = useSnackbarStore();
  const [, setDebouncedSearchTerm] = useState("");
  const [translations, setTranslations] = useState([]);

  const { handleSubmit, setValue, reset, getValues } = methods;

  const { data: locales } = useQuery("locales", getAllLocales, {
    retries: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    retry: (failureCount, error) => {
      if (error.status === 404) return false;
      return failureCount <= 3;
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: superPowerTypes } = useQuery(
    "superPowerTypes",
    getAllSuperPowerTypes,
    {
      retries: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      retry: (failureCount, error) => {
        if (error.status === 404) return false;
        return failureCount <= 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const { data: models } = useQuery("models", getAllModels, {
    retries: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    retry: (failureCount, error) => {
      if (error.status === 404) return false;
      return failureCount <= 3;
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const columns = [
    { ref: "id", value: "ID" },
    { ref: "name", value: "Nombre" },
    { ref: "slug", value: "Slug" },
    { ref: "credits", value: "Créditos" },
  ];

  const translationColumns = [
    { ref: "system", value: "System Prompt" },
    { ref: "description", value: "Descripción" },
    { ref: "tag", value: "Etiqueta" },
    { ref: "locale", value: "Idioma" },
  ];

  const handleDelete = (row) => {
    const item = row?.data;
    // Mostrar ventana de confirmación
    if (window.confirm(`¿Estás seguro de que quieres eliminar el superpoder Seleccionado?`)) {
     if(item?.id){
      mutationRemoveSuperPower.mutate(item.id)
     }
    }
  };

  const handleDeleteTranslation = (row) => {
    const item = row?.data;
    console.log('item ', item);
    // Mostrar ventana de confirmación
    if (window.confirm(`¿Estás seguro de que quieres eliminar la traduccion Seleccionada?`)) {
     if(item?.id){
      mutationRemoveSuperPowerTranslation.mutate(item.id)
     }
    }
  };

  const handlePage = (nextPage) => {
    setPage(nextPage);
    setSearchLoading(true);
    mutationSuperPowers.mutate({ page: nextPage });
  };

  const handleEdit = (row) => {
    const item = row.data;
    Object.keys(item).forEach((key) => {
      setValue(key, item[key]);
    });
    setValue("model", item?.model_id?.id);
    setValue("type", item?.super_power_type_id?.id);
    setSelected(item);
    if (item?.translations?.length) {
      const parsedTranslations = item.translations.map((e) => ({
        id: e.id,
        system: e.system,
        tag: e.tag,
        description: e.description,
        locale: e.locale.name,
      }));
      setTranslations(parsedTranslations);
    }
    setOpenModal(true);
  };

  const onClose = () => {
    setOpenModal(false);
    reset();
    setSelected(null);
    setTranslations([]);
    setSelectedTranslation([]);
  };

  const onClose2 = () => {
    setOpenModal2(false);
    setValue("tag", "");
    setValue("description", "");
    setValue("system", "");
    setValue("locale", "");
    setValue("translationId", "");
    setSelectedTranslation(null);
  };

  const handleNew = () => {
    reset();
    setSelected(null);
    setOpenModal(true);
    setTranslations([]);
    setSelectedTranslation([]);
    if (locales?.length) {
      setValue("locale", locales[0].name);
    }
    if (superPowerTypes?.length) {
      setValue("type", superPowerTypes[0].id);
    }

    if (models?.length) {
      setValue("model", models[0].id);
    }
  };

  const openTranslations = () => {
    if (locales?.length) {
      setValue("locale", locales[0].name);
    }
    setOpenModal2(true);
  };

  const addTranslation = () => {
    const formData = getValues();
    if(formData.locale !== selectedTranslation?.locale && translations.some(e => e.locale === formData.locale)){
      show(`La traducción ${formData.locale} ya existe`,'error');
      return
    }
    if (selectedTranslation && Object.values(selectedTranslation).length && selectedTranslation.id === formData?.translationId) {
      const { tag, description, system, locale } = formData;
      const updatedTranslations = translations.map((t) => {
        if (t.id === selectedTranslation.id) {
          return { ...t, tag, description, system, locale };
        }
        return t;
      });
      setTranslations(updatedTranslations);
    } else {
      const newTranslation = {
        id: uuidv4(),
        system: formData.system,
        tag: formData.tag,
        description: formData.description,
        locale: formData.locale,
      };

      setTranslations([...translations, newTranslation]);
    }

    onClose2();
  };

  const handleEditTranslation = (row) => {
    const { tag, description, system, locale, id } = row.data;
    setValue("tag", tag);
    setValue("description", description);
    setValue("system", system);
    setValue("locale", locale);
    setValue("translationId", id)
    setSelectedTranslation({ tag, description, system, locale, id });
    setOpenModal2(true);
  };

  const getLocaleIdByName = (localeId) => {
    const locale = locales.find((l) => l.name === localeId);
    return locale ? locale.id : "";
  };

  const onSubmit = (formData) => {
    const formDataToSend = new FormData();
    formDataToSend.append("name", String(formData.name));
    formDataToSend.append("slug", String(formData.slug));
    formDataToSend.append("frontend_route", String(formData.frontend_route));
    formDataToSend.append("credits", Number(formData.credits));
    formDataToSend.append("type", Number(formData.type));
    formDataToSend.append("model", Number(formData.model));
    formDataToSend.append("is_new", Boolean(formData.is_new));
    formDataToSend.append("is_default", Boolean(formData.is_default));
    formDataToSend.append("show", Boolean(formData.show));
    if (translations.length) {
      const translationDataForTable = translations.map((t) => ({
        ...t,
        locale: getLocaleIdByName(t.locale), // Aquí reemplazas el ID con el nombre del idioma
      }));

      formDataToSend.append(
        "translations",
        JSON.stringify(translationDataForTable)
      );
    }
    for (let [key, value] of formDataToSend.entries()) {
      console.log(`key ${key} --- value ${value}`);
    }

    setLoading(true);
    const body = formDataToSend;
    if (selected) {
      mutationUpdateSuperPower.mutate({
        id: selected.id,
        body,
      });
    } else {
      mutationStoreSuperPower.mutate(body);
    }
  };

  // eslint-disable-next-line
  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      setSearchLoading(true);
      mutationSuperPowers.mutate({ page, name: searchTerm });
    }, 500),

    [page]
  );

  const mutationStoreSuperPower = useMutation(storeSuperPower, {
    onSuccess: (data) => {
      const currentItem = data;
      Object.keys(currentItem).forEach((key) => {
        setValue(key, currentItem[key]);
      });
      setSelected(currentItem);
      setLoading(false);
      show("Registro Creado");
      setSearchLoading(true);
      mutationSuperPowers.mutate({ page });
    },
    onError: (error) => {},
  });

  const mutationUpdateSuperPower = useMutation(updateSuperPower, {
    onSuccess: (data) => {
      const currentItem = data;
      Object.keys(currentItem).forEach((key) => {
        setValue(key, currentItem[key]);
      });
      setSelected(currentItem);
      if (currentItem?.translations?.length) {
        const parsedTranslations = currentItem.translations.map((e) => ({
          id: e.id,
          system: e.system,
          tag: e.tag,
          description: e.description,
          locale: e.locale.id,
        }));
        setTranslations(parsedTranslations);
      }
      setLoading(false);
      show("Registro Actualizado");
    },
    onError: (error) => {},
  });

  const mutationSuperPowers = useMutation(getSuperPowers, {
    onSuccess: (res) => {
      setSuperPowers(res.results);
      setSearchLoading(false);
    },
    onError: () => {},
  });

  const mutationRemoveSuperPower = useMutation(deleteSuperPower, {
    onSuccess: (res) => {
      mutationSuperPowers.mutate({ page: page });
      onClose()
    },
    onError: () => {},
  });

  const mutationRemoveSuperPowerTranslation = useMutation(deleteSuperPowerTranslation, {
    onSuccess: (res) => {
      mutationSuperPowers.mutate({ page: page });
      const currentItem = res;
      Object.keys(currentItem).forEach((key) => {
        setValue(key, currentItem[key]);
      });
      setSelected(currentItem);
      if (currentItem?.translations?.length) {
        const parsedTranslations = currentItem.translations.map((e) => ({
          id: e.id,
          system: e.system,
          tag: e.tag,
          description: e.description,
          locale: e.locale.id,
        }));
        setTranslations(parsedTranslations);
      }
      setLoading(false);
      show("Registro Actualizado");
    },
    onError: () => {},
  });

  useEffect(() => {
    // Crea una función debounced que actualiza debouncedSearchTerm
    const debouncedUpdate = debounce((search) => {
      setDebouncedSearchTerm(search);
    }, 500); // 500 ms de espera

    if (searchTerm) {
      debouncedUpdate(searchTerm);
    }

    // Limpia el debounce si el componente se desmonta o el searchTerm cambia
    return () => debouncedUpdate.cancel();
    // eslint-disable-next-line
  }, [searchTerm]);

  useEffect(() => {
    mutationSuperPowers.mutate({ page: page });
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="my-4 flex justify-end items-center">
        <div className="relative w-64 mr-4">
          <input
            type="text"
            className="border border-gray-300 rounded-lg py-2 pl-10 pr-4"
            placeholder="Buscar"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              debouncedSearch(e.target.value);
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded button-primary"
          onClick={() => handleNew()}
        >
          Agregar
        </button>
      </div>
      <div>
        <DataTable
          data={superPowers}
          height={600}
          headerColumns={columns}
          handleSelect={handleEdit}
          handleDelete={handleDelete}
          loading={searchLoading}
        />
        <div className="flex justify-end">
          <div className=" flex p-2 gap-2">
            {page > 1 && (
              <div>
                <button
                  onClick={() => handlePage(page - 1)}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded button-primary"
                >
                  Anterior
                </button>
              </div>
            )}

            <div>
              <button
                onClick={() => handlePage(page + 1)}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded button-primary"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal3
        isOpen={openModal}
        onClose={onClose}
        customStyles={openModal2 ? { height: 800 } : {}}
      >
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-row">
              <TextInput2
                label="Nombre"
                name="name"
                placeHolder="Actividad"
                required
              />

              <TextInput2
                label="Slug"
                name="slug"
                placeHolder="Escribe un nombre unico"
                required
              />

              <TextInput2
                label="Créditos"
                name="credits"
                placeHolder=""
                type="number"
                required
              />

              <TextInput2
                label="Ruta Frontend"
                name="frontend_route"
                placeHolder="/activity"
              />
            </div>
            <div className="input-row">
              <div className="flex w-full justify-around gap-8">
                <div className="input-text flex flex-row justify-end w-full gap-6">
                  <div className="input-label text-shaiaBlue w-[50%] flex items-center justify-center ">
                    Default
                  </div>
                  <div className="w-[50%] flex items-center pt-3">
                    <Controller
                      control={methods.control}
                      name="is_default"
                      render={({ field: { onChange, value } }) => (
                        <ToggleSwitch3
                          onChange={onChange}
                          checked={value} // React Hook Form maneja este estado
                          trueLabel="Si"
                          falseLabel="No"
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="input-text flex flex-row justify-end w-full gap-6">
                  <div className="input-label text-shaiaBlue w-[50%] flex items-center justify-center ">
                    Mostrar
                  </div>
                  <div className="w-[50%] flex items-center pt-3">
                    <Controller
                      control={methods.control}
                      name="show"
                      render={({ field: { onChange, value } }) => (
                        <ToggleSwitch3
                          onChange={onChange}
                          checked={value} // React Hook Form maneja este estado
                          trueLabel="Si"
                          falseLabel="No"
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="input-text flex flex-row justify-end w-full gap-6">
                  <div className="input-label text-shaiaBlue w-[50%] flex items-center justify-center ">
                    Nuevo
                  </div>
                  <div className="w-[50%] flex items-center pt-3">
                    <Controller
                      control={methods.control}
                      name="is_new"
                      render={({ field: { onChange, value } }) => (
                        <ToggleSwitch3
                          onChange={onChange}
                          checked={value} // React Hook Form maneja este estado
                          trueLabel="Si"
                          falseLabel="No"
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="input-row">
              <SelectInput
                control={methods.control}
                name="model"
                label="Modelo"
                options={models?.map((e) => ({
                  value: e.id,
                  description: e.name,
                }))}
                required={openModal2}
              />
              <SelectInput
                control={methods.control}
                name="type"
                label="Tipo de Super Poder"
                options={superPowerTypes?.map((e) => ({
                  value: e.id,
                  description: e.name,
                }))}
                required={openModal2}
              />
            </div>
            <div className="input-row">
              <div className="flex flex-col w-full">
                <div className="text-center input-label">Traducciones</div>
                <div className="text-right">
                  <button
                    type="button"
                    onClick={openTranslations}
                    className="bg-shaiaBlue text-DarkBlue-500 font-bold rounded text-sm p-2 mb-4"
                  >
                    Agregar
                  </button>
                </div>
                <div>
                  <DataTable
                    data={translations}
                    height={translations.length ? 200 : 100}
                    headerColumns={translationColumns}
                    handleSelect={handleEditTranslation}
                    handleDelete={handleDeleteTranslation}
                  />
                </div>
              </div>

              <SecondModal isOpen={openModal2} onClose={onClose2}>
                <div className="input-row">
                  <Controller
                    name="translationId" // Este será el nombre del campo en el formulario
                    control={methods.control}
                    render={({ field }) => <input {...field} type="hidden" />}
                  />
                  <TextInput2
                    label="Etiqueta"
                    name="tag"
                    placeHolder="Escribe una etiqueta"
                    required={openModal2}
                  />
                  <SelectInput
                    control={methods.control}
                    name="locale"
                    label="Idioma"
                    options={locales?.map((e) => ({
                      value: e.name,
                      description: e.name,
                    }))}
                    required={openModal2}
                  />
                </div>
                <div className="input-row pb-[-10px]">
                  <TextArea2
                    label="System Prompt"
                    name="system"
                    placeholder="Escribe el prompt"
                    required={openModal2}
                  />
                </div>
                <div className="input-row">
                  <TextArea2
                    label="Descripcion"
                    name="description"
                    placeholder="Escribe la description del super poder"
                    required={openModal2}
                  />
                </div>
                <div className="input-row mt-4 pt-8">
                  <button
                    type="button"
                    onClick={addTranslation}
                    className="bg-shaiaBlue text-DarkBlue-500 font-bold rounded text-sm p-2"
                  >
                    Guardar
                  </button>
                </div>
              </SecondModal>
            </div>
            <div className="input-row mt-4 pt-8">
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded button-primary"
              >
                {loading ? "Enviando..." : selected ? "Actualizar" : "Crear"}
              </button>
            </div>
          </form>
        </FormProvider>
      </Modal3>
    </div>
  );
};

export default SuperPower;
